import React from 'react';
import './body.css';
import { Link } from 'react-router-dom';
import { IoIosArrowDroprightCircle } from "react-icons/io";
// import Mission from './mission';
import Test from './test';

const Body = () => {

    return (
        <>
            <div className='body' data-aos="fade-up">

                <div className='content-item'>
                    <div className='welcome-content'>

                        <div className="welcome-right">
                            <img src={require("../../assets/overview.jpg")} alt="" />

                        </div>

                        <div className="welcome-left">
                            <h2 className='content-title'>Welcome To Rooba Swastha Pharmaceuticals</h2>
                            <p>Rooba Swastha Pharmaceuticals is a growing company dedicated to providing affordable, high-quality generic medicines. We partner with reliable, WHO-GMP & ISO-certified manufacturers to ensure every product meets global quality and safety standards. This strong commitment allows us to deliver medicines that are not only effective but also trusted by healthcare professionals and patients. Our motto, <b>"Affordable Healthcare for All,"</b> drives us to bridge the gap between quality and accessibility, making us a dependable partner in healthcare.</p>

                            <button className='btn'>

                                <Link to="/about" >Read More</Link>

                            </button>
                        </div>





                    </div>

                </div>

                

                {/* <Mission/> */}
                <Test/>



                <div className="why-choose-container" data-aos="fade-up">
                    <div className="why-choose-content">

                        <h2 className='content-title'>Why choose Rooba Swastha Pharmaceuticals </h2>
                        <p>At Rooba Swastha Pharmaceuticals, our work is guided by our core values, which reflect our
                            deep commitment to our customers and partners.</p>
                        <div className="why-choose-list">

                            <div className="why-choose-list-item-left">
                                <div className='list-content'>
                                    <div className="why-choose-list-item-title">
                                        <IoIosArrowDroprightCircle className='icon' />
                                        <h3>Quality </h3>
                                    </div>
                                    <p>Our dedication to quality excellence means we adhere to the highest standards.</p>

                                </div>

                                <div className='list-content'>
                                    <div className="why-choose-list-item-title">
                                        <IoIosArrowDroprightCircle className='icon' />
                                        <h3>Affordability</h3>
                                    </div>
                                    <p> We believe that affordability is key,
                                        ensuring our medicines are accessible to everyone and making quality healthcare affordable
                                        for all.</p>
                                </div>

                                <div className='list-content'>

                                    <div className="why-choose-list-item-title">
                                        <IoIosArrowDroprightCircle className='icon' />
                                        <h3>Integrity</h3>
                                    </div>
                                    <p>We operate with unwavering integrity and a strong sense of social responsibility, putting patient
                                        well-being at the heart of every decision.</p>

                                </div>

                                <div className='list-content'>

                                    <div className="why-choose-list-item-title">
                                        <IoIosArrowDroprightCircle className='icon' />
                                        <h3>Innovation</h3>
                                    </div>
                                    <p>Through innovation and collaboration, we strive
                                        to shape the future of generic medicines and expand access to care. </p>
                                </div>
                            </div>

                            <div className="why-choose-list-item-right">

                                <img src={require("../../assets/why-us.jpg")} alt="" />

                            </div>

                        </div>



                    </div>


                </div>



            </div>

        </>

    );
}

export default Body;
